import { CompetitionVm, MatchDetailVm, TeamVm } from '../../../utils/api';
import MatchScoreboard from './MatchScoreboard';

export interface Props {
    match?: MatchDetailVm;
    competition?: CompetitionVm;
    homeTeam?: TeamVm;
    awayTeam?: TeamVm;
    onBackToApp?: () => void;
    onSaveMatchLog?: () => void;
    onLivescoreClick?: () => void;
    hasUnsavedMatchLogChanges?: boolean;
    matchLogDirtyBaselineReady?: boolean;
}

export default MatchScoreboard;
